import { render, staticRenderFns } from "./CreateNewFormModal.vue?vue&type=template&id=5ab28e0c&scoped=true&"
import script from "./CreateNewFormModal.vue?vue&type=script&lang=js&"
export * from "./CreateNewFormModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewFormModal.vue?vue&type=style&index=0&id=5ab28e0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab28e0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab28e0c')) {
      api.createRecord('5ab28e0c', component.options)
    } else {
      api.reload('5ab28e0c', component.options)
    }
    module.hot.accept("./CreateNewFormModal.vue?vue&type=template&id=5ab28e0c&scoped=true&", function () {
      api.rerender('5ab28e0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/dialog/CreateNewFormModal.vue"
export default component.exports